import styled, { css } from "styled-components";

export const Wrapper = styled("div")<{ disabled: boolean }>`
  height: 100%;
  width: 100%;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;

  ${({ disabled }) =>
    disabled &&
    css`
      overflow: hidden;
      pointer-events: none;
    `}
`;
